import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-three-two-two-one',
  templateUrl: './three-two-two-one.component.html',
  styleUrls: ['./three-two-two-one.component.scss']
})
export class ThreeTwoTwoOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
